__turbopack_context__.v({
  "HeroContentWrapper": "HeroBanner-module-scss-module__UKNuga__HeroContentWrapper",
  "HeroTextBanner": "HeroBanner-module-scss-module__UKNuga__HeroTextBanner",
  "HeroTextBanner__Image": "HeroBanner-module-scss-module__UKNuga__HeroTextBanner__Image",
  "HeroTextBanner__InfoContent": "HeroBanner-module-scss-module__UKNuga__HeroTextBanner__InfoContent",
  "HeroTextBanner__SubTitle": "HeroBanner-module-scss-module__UKNuga__HeroTextBanner__SubTitle",
  "HeroTextBanner__Title": "HeroBanner-module-scss-module__UKNuga__HeroTextBanner__Title",
  "HeroTextBanner__Title_min": "HeroBanner-module-scss-module__UKNuga__HeroTextBanner__Title_min",
  "HeroTextWrapper": "HeroBanner-module-scss-module__UKNuga__HeroTextWrapper",
});
